import { useDevice } from '@lune-fe/lune-ui-lib'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import Image from 'next/image'

const Profile = ({
    avatar,
    name,
    title,
    textColor,
    logo,
    date,
}: {
    avatar?: React.ReactNode
    name: string
    title: string
    textColor?: string
    logo?: string
    date?: string
}) => {
    const { xsScreen } = useDevice()
    const color = textColor ?? 'Grey900'
    return (
        <Stack
            direction="row"
            spacing={{
                xs: 2,
                sm: 4,
                md: 4,
                lg: 4,
                xl: 4,
            }}
        >
            {avatar && (
                <Avatar
                    alt={name}
                    sx={{
                        height: {
                            xs: 56,
                            sm: 80,
                            md: 80,
                            lg: 80,
                            xl: 80,
                        },
                        width: {
                            xs: 56,
                            sm: 80,
                            md: 80,
                            lg: 80,
                            xl: 80,
                        },
                        margin: 0,
                    }}
                >
                    {avatar}
                </Avatar>
            )}
            <Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={0.5}>
                <Text color={color} variant={xsScreen ? 'h6' : 'h5'} component="span">
                    {name}
                </Text>
                <Text color={color} variant={xsScreen ? 'body2' : 'body1'} component="span">
                    {title + (date ? `, ${date}` : '')}
                </Text>
                {logo && (
                    <Box py={1}>
                        <Image height={40} src={logo} alt={`Logo`} />
                    </Box>
                )}
            </Stack>
        </Stack>
    )
}

export default Profile
